import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const ns = ['locale', 'resource', 'labels', 'validation', 'common'];
const supportedLngs = [
  'amh',
  'ar',
  'de',
  'et',
  'en',
  'es',
  'es-BO',
  'fr',
  'id',
  'it',
  'ja',
  'km',
  'lo',
  'nl',
  'pl',
  'pt',
  'ro',
  'ru',
  'vi',
  'zh',
  'zh-TW',
];

const resources = ns.reduce((acc, n) => {
  supportedLngs.forEach((lng) => {
    if (!acc[lng]) acc[lng] = {};
    acc[lng] = {
      ...acc[lng],
      // eslint-disable-next-line import/no-dynamic-require
      [n]: require(`./locales/${lng}/${n}.json`),
    };
  });
  return acc;
}, {});

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    detection: { caches: [] },
    resources,
    // lng: "es",
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    debug: false,
    fallbackLng: 'en',
    nonExplicitSupportedLngs: true,
    defaultNS: 'common',
    ns,
    supportedLngs,
    useLocalStorage: false,
  });

export default i18n;
